<i18n src="@/lang/actions.json" />

<template>
  <el-dialog
    title="Tips"
    :visible.sync="dialogVisible"
    width="500px"
    append-to-body
  >
    <el-form>
      <el-form-item label="Currency">
        <el-input v-model="cost.name" size="small" required />
      </el-form-item>
      <el-form-item label="Price">
        <el-input v-model="cost.value" size="small" type="number" />
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleCancel" v-t="'actions.cancel'" />
      <el-button
        type="primary"
        @click="handleAdd"
        :disabled="!cost.name"
        v-t="'actions.add'"
      />
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: "addNewTariffCost",
  props: {
    value: {
      type: Object,
      default: () => ({})
    },
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      cost: {
        name: this.value.name || "",
        value: this.value.calue || ""
      }
    };
  },
  watch: {
    cost: {
      handler: function() {
        this.$emit("input", this.cost);
      },
      deep: true
    }
  },
  methods: {
    handleAdd() {
      this.$emit("add", this.cost);
      this.dialogVisible = false;
    },
    handleCancel() {
      this.$emit("cancel");
      this.dialogVisible = false;
    }
  },
  computed: {
    dialogVisible: {
      get: function() {
        return this.visible;
      },
      set: function(v) {
        this.$emit("update:visible", v);
      }
    }
  }
};
</script>

<style scoped></style>
